var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tribute-gallery"},_vm._l((_vm.tributes),function(tribute,index){return _c('TributeItem',{key:index,class:("item-" + (index % 2) + " tribute-list"),attrs:{"transition":"stagger","stagger":"100","tribute":tribute}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }